module.exports = __webpack_public_path__ + "static/img/Aaron-Naughton.96a8531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aaron-Naughton.jpg
// module id = OQk6
// module chunks = 0